export default function CaseResults() {
  return (
    <section id="cases" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Результаты наших клиентов
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 mb-12">
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 overflow-hidden rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20corporate%20office%20interior%20modern%20logistics%20company%20headquarters%20with%20team%20working%20at%20desks%20warm%20natural%20lighting%20clean%20elegant%20design%20glass%20partitions%20industrial%20details&width=200&height=200&seq=case-logistics&orientation=squarish"
                  alt="Международная логистическая компания"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-xs font-semibold text-teal-600 tracking-wider mb-1">КЕЙС 1</div>
                <h3 className="text-xl font-bold text-gray-900">Международная логистическая компания</h3>
              </div>
            </div>

            <div className="space-y-5">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 bg-red-100 rounded flex items-center justify-center flex-shrink-0">
                    <i className="ri-error-warning-line text-red-500 text-xs"></i>
                  </div>
                  <span className="font-semibold text-gray-900 text-sm">Проблема</span>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed pl-8">
                  Низкая конверсия телефонных продаж. Менеджеры проводили много звонков, но сделки не росли. Типичный сценарий: звонок — отправка КП — молчание клиента.
                </p>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 bg-teal-100 rounded flex items-center justify-center flex-shrink-0">
                    <i className="ri-tools-line text-teal-600 text-xs"></i>
                  </div>
                  <span className="font-semibold text-gray-900 text-sm">Что сделали</span>
                </div>
                <div className="pl-8 flex flex-wrap gap-2">
                  {['Аудит звонков', 'Диагностика', 'Тренинг', 'Сопровождение', 'Разбор переговоров', 'Практика'].map((tag, i) => (
                    <span key={i} className="bg-teal-50 text-teal-700 text-xs px-3 py-1.5 rounded-full font-medium border border-teal-100">{tag}</span>
                  ))}
                </div>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 bg-green-100 rounded flex items-center justify-center flex-shrink-0">
                    <i className="ri-line-chart-line text-green-600 text-xs"></i>
                  </div>
                  <span className="font-semibold text-gray-900 text-sm">Результат</span>
                </div>
                <div className="pl-8">
                  <p className="text-sm text-gray-600 leading-relaxed mb-2">
                    Конверсия выросла на <strong className="text-teal-600 text-lg">18–23%</strong>
                  </p>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    месяц к месяцу после сопровождения. Менеджеры стали назначать в два раза больше встреч при том же количестве звонков.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 overflow-hidden rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20real%20estate%20agency%20office%20interior%20with%20professional%20team%20working%20desks%20clean%20bright%20design%20white%20walls%20plants%20natural%20light%20warm%20atmosphere%20expert%20professional%20setting&width=200&height=200&seq=case-realestate&orientation=squarish"
                  alt="Агентство недвижимости"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-xs font-semibold text-teal-600 tracking-wider mb-1">КЕЙС 2</div>
                <h3 className="text-xl font-bold text-gray-900">Агентство недвижимости</h3>
              </div>
            </div>

            <div className="space-y-5">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 bg-red-100 rounded flex items-center justify-center flex-shrink-0">
                    <i className="ri-error-warning-line text-red-500 text-xs"></i>
                  </div>
                  <span className="font-semibold text-gray-900 text-sm">Проблема</span>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed pl-8">
                  Холодные звонки приносили минимальный результат. Менеджеры избегали обзвона, предпочитая входящий трафик. Конверсия в договор была низкой.
                </p>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 bg-teal-100 rounded flex items-center justify-center flex-shrink-0">
                    <i className="ri-tools-line text-teal-600 text-xs"></i>
                  </div>
                  <span className="font-semibold text-gray-900 text-sm">Что сделали</span>
                </div>
                <div className="pl-8 flex flex-wrap gap-2">
                  {['Бизнес-игры', 'Практикум по звонкам', 'Сопровождение', 'Разбор звонков', 'SPIN-вопросы'].map((tag, i) => (
                    <span key={i} className="bg-teal-50 text-teal-700 text-xs px-3 py-1.5 rounded-full font-medium border border-teal-100">{tag}</span>
                  ))}
                </div>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 bg-green-100 rounded flex items-center justify-center flex-shrink-0">
                    <i className="ri-line-chart-line text-green-600 text-xs"></i>
                  </div>
                  <span className="font-semibold text-gray-900 text-sm">Результат</span>
                </div>
                <div className="pl-8">
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Количество договоров, заключённых после холодных звонков, увеличилось <strong className="text-teal-600 text-lg">более чем в два раза</strong> после серии бизнес-игр, практикумов и сопровождения.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}